export const homeHero = {
  title: "Self-Serve Dog Wash Stations in Glasgow for Dog Owners",
  subtitle:
    "Quick clean for your dog, saves your home and car, open 24/7",
};

export const homeMeta = {
  title: "Pawwash | Self-Serve Dog Wash Stations in Glasgow",
  description:
    "Find 24/7 self-serve dog wash stations in Glasgow and Scotland. £10 for 10 minutes — quick, convenient washing without the mess at home.",
  path: "/",
};

export const homeEntity = {
  title: "What is Pawwash?",
  definition:
    "Pawwash is a network of 24/7 self-serve dog wash stations at Speed Queen laundry sites across Glasgow and Scotland. Each session costs £10 for 10 minutes and includes shampoo, warm rinse, conditioner, blow dry, and tub disinfect.",
};

export const homeKeyFacts = [
  { label: "Price", value: "£10 for 10 minutes" },
  { label: "Hours", value: "24/7 at participating locations" },
  { label: "Payment", value: "Card only at the station — no booking required" },
  { label: "Service area", value: "Glasgow and Scotland" },
  {
    label: "Included",
    value:
      "Shampoo, warm rinse, conditioner, anti-flea treatment, blow dry, and tub disinfect",
  },
];

export const homeCrossLinks = [
  {
    title: "How it works",
    text: "Wash your dog in about 10 minutes — secure your dog, pay at the station, then shampoo, rinse, condition, blow dry, and disinfect the tub.",
    href: "/demo",
    linkLabel: "See the full step-by-step guide",
  },
  {
    title: "Pricing",
    text: "A flat rate of £10 covers 10 minutes of washing time with all products included.",
    href: "/pricing",
    linkLabel: "View pricing details",
  },
];

export const locationsHeading = "Pawwash locations in Scotland";
